import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/icon_left.png';
import _imports_1 from '../../assets/icon_right.png';
import _imports_2 from '../../assets/product_img2.png';
import _imports_3 from '../../assets/product_img3.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-42b37a38"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "top",
  id: "content"
};
var _hoisted_2 = {
  key: 0,
  class: "banner"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "icon"
  }, null, -1);
});

var _hoisted_4 = [_hoisted_3];

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "icon"
  }, null, -1);
});

var _hoisted_6 = [_hoisted_5];
var _hoisted_7 = ["src"];

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner_e"
  }, "PAPER-LIKE READING", -1);
});

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner_name"
  }, "＠BC60A启明星", -1);
});

var _hoisted_10 = {
  class: "banner_circle2"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "circle2_text1"
  }, "BC60A启明星", -1);
});

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "circle2_text2"
  }, "专为青少年健康数字阅读打造", -1);
});

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "circle2_text3"
  }, "全国首款儿童专用彩色电子纸终端", -1);
});

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "circle_btn_text"
  }, "了解更多", -1);
});

var _hoisted_15 = {
  key: 1,
  class: "banner1"
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "icon"
  }, null, -1);
});

var _hoisted_17 = [_hoisted_16];

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "icon"
  }, null, -1);
});

var _hoisted_19 = [_hoisted_18];
var _hoisted_20 = ["src"];

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner_e"
  }, "PAPER-LIKE READING", -1);
});

var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner_name"
  }, "＠BC520绘本通", -1);
});

var _hoisted_23 = {
  class: "banner_circle"
};

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "circle_text1"
  }, "BC520绘本通", -1);
});

var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "circle_text2"
  }, "专为儿童打造的阅读器", -1);
});

var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "circle_text3"
  }, "全国首款儿童专用彩色电子纸终端", -1);
});

var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "circle_btn_text"
  }, "了解更多", -1);
});

var _hoisted_28 = {
  class: "indicator"
};
var _hoisted_29 = {
  key: 0,
  class: "indicator2"
};
var _hoisted_30 = {
  key: 2,
  class: "indicator2"
};
var _hoisted_31 = {
  class: "content"
};

var _hoisted_32 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "content_title"
  }, "EXTERIOR DISPLAY", -1);
});

var _hoisted_33 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "content_abs"
  }, "外观展示", -1);
});

var _hoisted_34 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "content_border"
  }, null, -1);
});

var _hoisted_35 = {
  class: "banner2"
};
var _hoisted_36 = {
  key: 0,
  src: _imports_2,
  class: "banner2_img"
};
var _hoisted_37 = {
  key: 1,
  src: _imports_3,
  class: "banner2_img2"
};
var _hoisted_38 = {
  key: 2,
  class: "banner2_abs"
};
var _hoisted_39 = {
  class: "banner2_abs_text1"
};
var _hoisted_40 = {
  class: "banner2_abs_text2"
};
var _hoisted_41 = {
  class: "banner2_abs_text3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Right = _resolveComponent("Right");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_carousel_item = _resolveComponent("el-carousel-item");

  var _component_el_carousel = _resolveComponent("el-carousel");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_carousel, {
    interval: 5000,
    arrow: "never",
    ref: "topbanner",
    "indicator-position": "none",
    onChange: _ctx.changeItem
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerList, function (item) {
        return _openBlock(), _createBlock(_component_el_carousel_item, {
          key: item,
          class: "aaa"
        }, {
          default: _withCtx(function () {
            return [item.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
              class: "pre2",
              onClick: _cache[0] || (_cache[0] = function () {
                return _ctx.pre && _ctx.pre.apply(_ctx, arguments);
              })
            }, _hoisted_4), _createElementVNode("div", {
              class: "next2",
              onClick: _cache[1] || (_cache[1] = function () {
                return _ctx.next && _ctx.next.apply(_ctx, arguments);
              })
            }, _hoisted_6), _createElementVNode("img", {
              src: item.url,
              class: "banner_img1"
            }, null, 8, _hoisted_7), _hoisted_8, _hoisted_9, _createElementVNode("div", _hoisted_10, [_hoisted_11, _hoisted_12, _hoisted_13, _createElementVNode("div", {
              class: "circle_btn",
              onClick: _cache[2] || (_cache[2] = function () {
                return _ctx.handleQimingxing && _ctx.handleQimingxing.apply(_ctx, arguments);
              })
            }, [_hoisted_14, _createVNode(_component_el_icon, {
              color: "#fff"
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_Right)];
              }),
              _: 1
            })])])])) : _createCommentVNode("", true), item.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", {
              class: "pre",
              onClick: _cache[3] || (_cache[3] = function () {
                return _ctx.pre && _ctx.pre.apply(_ctx, arguments);
              })
            }, _hoisted_17), _createElementVNode("div", {
              class: "next",
              onClick: _cache[4] || (_cache[4] = function () {
                return _ctx.next && _ctx.next.apply(_ctx, arguments);
              })
            }, _hoisted_19), _createElementVNode("img", {
              src: item.url,
              class: "banner_img"
            }, null, 8, _hoisted_20), _hoisted_21, _hoisted_22, _createElementVNode("div", _hoisted_23, [_hoisted_24, _hoisted_25, _hoisted_26, _createElementVNode("div", {
              class: "circle_btn",
              onClick: _cache[5] || (_cache[5] = function () {
                return _ctx.handleHuiben && _ctx.handleHuiben.apply(_ctx, arguments);
              })
            }, [_hoisted_27, _createVNode(_component_el_icon, {
              color: "#fff"
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_Right)];
              }),
              _: 1
            })])])])) : _createCommentVNode("", true)];
          }),
          _: 2
        }, 1024);
      }), 128)), _createElementVNode("div", _hoisted_28, [_ctx.banner_active == 0 || _ctx.banner_active == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_29)) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "indicator1",
        onClick: _cache[6] || (_cache[6] = function () {
          return _ctx.pre && _ctx.pre.apply(_ctx, arguments);
        })
      })), _ctx.banner_active == 1 || _ctx.banner_active == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_30)) : (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "indicator1",
        onClick: _cache[7] || (_cache[7] = function () {
          return _ctx.next && _ctx.next.apply(_ctx, arguments);
        })
      }))])];
    }),
    _: 1
  }, 8, ["onChange"])]), _createElementVNode("div", _hoisted_31, [_hoisted_32, _hoisted_33, _hoisted_34, _createElementVNode("div", _hoisted_35, [_createVNode(_component_el_carousel, {
    arrow: "never",
    autoplay: false,
    type: "card",
    "indicator-position": "none",
    onChange: _ctx.changeBanner
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerList2, function (item, index) {
        return _openBlock(), _createBlock(_component_el_carousel_item, {
          key: index
        }, {
          default: _withCtx(function () {
            return [item.type == 1 ? (_openBlock(), _createElementBlock("img", _hoisted_36)) : _createCommentVNode("", true), item.type == 2 ? (_openBlock(), _createElementBlock("img", _hoisted_37)) : _createCommentVNode("", true), _ctx.bannerIndex == index ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, _toDisplayString(item.text1), 1), _createElementVNode("div", _hoisted_40, _toDisplayString(item.text2), 1), _createElementVNode("div", _hoisted_41, _toDisplayString(item.text3), 1)])) : _createCommentVNode("", true)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }, 8, ["onChange"])])])], 64);
}